import { Outlet, useParams } from 'react-router-dom'

import { PageHeader } from '@/components/common/navigation/PageHeader'

import { SituacaoFinanceiraBadge } from '../components/situacao-financeira-badge'
import { useOrdemFinanceiro } from '../hooks/use-ordem-financeiro'

export default function Component({ isSale }: { isSale: boolean }) {
  const { orderId } = useParams()
  // Enquanto carrega ou se a leitura falhar, o selo simplesmente não aparece.
  const { query } = useOrdemFinanceiro(orderId, 'nao')

  const items = []
  if (isSale) {
    items.push({ title: 'Detalhes', path: 'detalhes' })
    items.push({ title: 'Itens', path: 'itens' })
    items.push({ title: 'Financeiro', path: 'financeiro' })
  } else {
    items.push({ title: 'Detalhes', path: 'detalhes' })
    items.push({ title: 'Técnico', path: 'tecnico' })
    items.push({ title: 'Itens', path: 'itens' })
    items.push({ title: 'Financeiro', path: 'financeiro' })
  }

  return (
    <>
      <PageHeader
        title={isSale ? 'Ordens de venda' : 'Ordens de serviço'}
        items={items}
        canReturn
        endContent={<SituacaoFinanceiraBadge situacao={query.data?.situacao} />}
      />
      <Outlet />
    </>
  )
}
